/** The "new link" callout after a revoke: cleared when its own link, or every link, was revoked. */
export function createdLinkAfterRevoke<T extends { token: string }>(
  created: T | null,
  revoked: string | "all"
): T | null {
  if (!created) return null;
  return revoked === "all" || created.token === revoked ? null : created;
}
